export enum InvestPoolStatus {
    Draft = 'Draft',
    Published = 'Published'
}